import { useMutation, useQueryClient } from '@tanstack/react-query'

import { Institution } from '@/domain/entities/institution.entity'
import { IInstitutionsService } from '@/services/contracts/institutions'
import { useParams } from 'react-router-dom'

type ListInstitutionsProps = {
  institutionsService: IInstitutionsService
}

export function useUpdateInstitution({
  institutionsService,
}: ListInstitutionsProps) {
  const queryClient = useQueryClient()
  const { id } = useParams()

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      id,
      institution,
    }: {
      id: string
      institution: Institution
    }) => institutionsService.update(id, institution),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`list_institution`, id],
      })
    },
  })

  return {
    updateInstitution: mutate,
    isPending,
  }
}
